module.exports = __webpack_public_path__ + "static/img/thirdly.c3fa9c33.png";